import { ReactElement } from "react";
import { Dialog } from "../../../../components/modal/Dialog";
import { SelectCustomerDialogContent } from "./SelectCustomerDialogContent";

export const SelectCustomerDialog = ({
  active,
  onDismiss,
}: {
  active: boolean;
  onDismiss: () => void;
}): ReactElement => {
  return (
    <Dialog active={active} onDismiss={onDismiss}>
      <SelectCustomerDialogContent onDismiss={onDismiss} />
    </Dialog>
  );
};
